module.exports = ".fi-paginator-centered\r\n{\r\n    margin-left: calc(50% - 91px);\r\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/paginator/paginator.component.css
 ** module id = 497
 ** module chunks = 0
 **/